// extracted by mini-css-extract-plugin
export default {"message":"ValidationMessage_message__G9cdS","error":"ValidationMessage_error__4mrj+","warning":"ValidationMessage_warning__d-c1R"};